module.exports = __webpack_public_path__ + "img/about-main.7ef4b4ff.webp";